import { useContext } from "react";
import classnames from "classnames";
import quoteService from "services/quote.service";
import Button, { COLOR, SIZE, STYLE } from "components/Button";
import { ErrorIcon } from "components/assets/Icons";
import { getRfqData } from "pages/Dashboard/utils";
import { Context } from "pages/Dashboard/Dashboard";

import styles from "./ErrorModal.module.scss";

const ErrorModal = ({
  setShowModal,
  errorMessage,
  setLoading,
  setPercentage,
  type,
  setAccepted,
  setDisabled,
  id,
  setEmptyState,
  state,
  rfqData,
  byId
}) => {
  const { setRfqData } = useContext(Context);
  const handleClick = () => {
    setShowModal(false);
    getRfqData({ setLoading, setPercentage, setRfqData, setEmptyState, state });
  };

  const takeAnyway = () => {
    quoteService.takeRFQ(id, true).then(
      ({ status, data }) => {
        if (status === 200) {
          if(rfqData.source === "syl_posted_orders" && !byId?.id) {
            quoteService.sendMsg(data?.chat_message);
          }
          setAccepted(true);
          setDisabled(false);
          setShowModal(false);
          getRfqData({ setLoading, setPercentage, setRfqData, setEmptyState, state });
        }
      },
      ({ response }) => {
        const { data } = response;
        setDisabled(false);
        console.error(data.error);
      },
    );
  };

  return (
    <>
      <ErrorIcon />
      <h2 className={styles.title}>ERROR</h2>
      <p className={classnames(styles.description, styles[type])}>
        {errorMessage && type !== "withButtonsGroup"
          ? errorMessage
          : "Ooops... This RfQ is already taken. Take this RfQ anyway?"}
      </p>
      {type === "withButtonsGroup" ? (
        <div className={styles.buttonsGroup}>
          <Button
            className={classnames(styles.button, styles.decline)}
            size={SIZE.MIDDLE}
            style={COLOR.NONE}
            onClick={() => setShowModal(false)}
          >
            BACK
          </Button>
          <Button className={styles.button} size={SIZE.MIDDLE} onClick={takeAnyway}>
            TAKE RQF
          </Button>
        </div>
      ) : (
        <Button className={styles.button} size={SIZE.MIDDLE} onClick={handleClick}>
          OK
        </Button>
      )}
    </>
  );
};

export default ErrorModal;
